module.exports = __webpack_public_path__ + "static/media/fanta.45f4b230.jpg";